export const Constants = {
  TAG_NAME: 'pop-key-fact-component',
  ATTRIBUTE_DISCLAIMER: 'data-disclaimer-code',
  CLASS_AS_OF_DATE: '.key-fact-as-of-date',
  CLASS_CONTENT: '.key-fact-content',
  CLASS_CONTENT_LONG: '.key-fact-content-long',
  CLASS_CONTENT_STARS: '.key-fact-content-stars',
  CLASS_KEY_FACT_CONTAINER: '.key-fact-container',
  CLASS_SUBCONTENT: '.key-fact-sub-content',
  CLASS_SUBTITLE: '.key-fact-subtitle',
  CLASS_TITLE: '.key-fact-title',
  DATA_VARIANT: 'data-variant',
  DATA_TITLE: 'data-title',
  DATA_CONTENT: 'data-content',
  DATA_SUB_CONTENT: 'data-sub-content',
  DATA_SUBTITLE: 'data-subtitle',
  DATA_TOOLTIP: 'data-tooltip',
  DATA_AS_OF_DATE: 'data-as-of-date',
  DATA_VALUE_FORMAT: 'data-value-format',
  DATA_DISCLAIMER_CODE: 'data-disclaimer-code',
  SUMMARY_KEY_FACTS_BLOCK: 'summary-key-facts-block',
  NOT_APPLICABLE: 'N/A',
} as const;
